import React from "react";
import { Row, Col, Card, CardTitle, CardText } from "reactstrap";

import BedSvg from "../../assets/img/svg/bed.svg";
import DeskSvg from "../../assets/img/svg/desk.svg";
import { SubTitle } from "../shared/SubTitle";

export const ServerPlants = ({ plants }) => {
  const type_plant = plants[0].get_type_display;
  let ilustration_plant = BedSvg;
  if (type_plant === "Mesas") {
    ilustration_plant = DeskSvg;
  }
  return (
    <>
      <SubTitle
        title={`Distribución de las ${type_plant}`}
        position="text-center"
      ></SubTitle>
      <Row>
        {plants.map((plant, index) => (
          <Col md="4" key={index}>
            <Card body className="card-plant">
              <CardTitle tag="h5">{plant.name}</CardTitle>
              <CardText>
                <strong>{plant.numero}</strong> {type_plant}
                <br />
                <img
                  className="img-fluid d-none d-md-block"
                  width={50}
                  src={ilustration_plant}
                  alt="illustration"
                />
                <span className="price-range">
                  $ {plant.price_to.toFixed(2)} - $ {plant.price.toFixed(2)}
                </span>
                <br /> Rango de Precios
              </CardText>
            </Card>
          </Col>
        ))}
      </Row>
    </>
  );
};
